import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SurveyQuestion, SurveyQuestionCategory } from '@ps/survey-utils';

import { SurveyQuestionApi } from '../../api/survey-question/survey-question.api';

@Injectable({ providedIn: 'root' })
export class SurveyQuestionService {
  private readonly _api = inject(SurveyQuestionApi);

  public getQuestions(
    search: string,
    categoryIds: number[],
  ): Observable<SurveyQuestion[]> {
    return this._api.getQuestions(search, categoryIds);
  }

  public categories(): Observable<SurveyQuestionCategory[]> {
    return this._api.categories();
  }
}
